export default __webpack_public_path__ + "static/media/114.3ea19363.png";